export default __webpack_public_path__ + "static/media/bol_scan_6.b4343e9a.svg";